// extracted by mini-css-extract-plugin
export default {"title":"InfoBlock_title__g-zud","infoBlock":"InfoBlock_infoBlock__+Og2z","slide-in":"InfoBlock_slide-in__8Mpk-","icon":"InfoBlock_icon__e0jDG","body":"InfoBlock_body__oDN58"};